import { formatJalaliShort } from '@shift/dates';
const PERSIAN = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
export function toPersianDigits(s) {
    return String(s).replace(/\d/g, (d) => PERSIAN[Number(d)] ?? d);
}
export function formatJalaliGrid(isoDate) {
    // formatJalaliShort returns "YYYY/MM/DD" with ASCII digits (see packages/dates/src/index.ts:138).
    return toPersianDigits(formatJalaliShort(isoDate).replace(/-/g, '/'));
}
export function formatRial(amount) {
    return toPersianDigits(amount.toLocaleString('en-US'));
}
